import React from "react";
import styles from "./Modal.module.scss";
import Button from "components/shared/button/Button";

const Modal = ({
  modalOpen,
  setModalOpen,
  heading,
  icon,
  children,
  blur = true,
  bottom = true,
  doNotClose = false,
  isCancel = false,
  isOk = false,
  onSubmit = () => { },
}) => {
  return (
    <React.Fragment>
      {modalOpen ? (
        <div
          className={blur ? styles.mainContainer : styles.mainContainer2}
          onMouseDown={(e) => {
            e.stopPropagation();
            !doNotClose && setModalOpen(false);
          }}
        >
          <div
            className={styles.modalDiv}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {heading && (
              <>
                <div className={styles.modalHeader}>
                  <p>{heading}</p>
                </div>
                <hr className={styles.horizontalLine} />
              </>
            )}
            <div className={styles.iconAndContent}>
              {icon && (
                <div className={styles.iconContainer}>
                  {<img className={styles.iconStyle} alt="icon" src={icon} />}
                </div>
              )}
              <div className={styles.modalBody}>
                <p>{children}</p>
              </div>
            </div>
            {bottom && (
              <>
                <hr className={styles.horizontalLine} />
                <div className={styles.twoButton}>
                  {
                    isOk ?
                      <Button
                        className={styles.blueButton}
                        onClick={() => setModalOpen((prev) => !prev)}
                      >
                        Ok
                      </Button>
                      :
                      <>
                        {isCancel && (
                          <Button
                            className={styles.whiteButton}
                            onClick={() => setModalOpen((prev) => !prev)}
                          >
                            Cancel
                          </Button>
                        )}
                        <Button
                          className={styles.blueButton}
                          onClick={(e) => {
                            onSubmit(e);
                            // isCancel && setModalOpen((prev) => !prev);
                            setModalOpen((prev) => !prev)
                          }}
                        >
                          {isCancel ? heading?.split(" ")[0] : "Done"}
                        </Button>
                      </>
                  }
                </div>
              </>
            )}
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Modal;
